module.exports = {
    RECEIVE_CONTACTS: 'RECEIVE_CONTACTS',
    RECEIVE_MESSAGES_OF: 'RECEIVE_MESSAGES_OF',
}
